import React from 'react'
import { Route, Switch, withRouter } from 'react-router-dom'
import { AdNetworkOverviewPage } from './ad-network-overview-page'

const AdNetworkRoutesRaw = () => {
  return (
    <Switch>
      <Route render={() => <AdNetworkOverviewPage />} />
    </Switch>
  )
}

export const AdNetworkRoutes = withRouter(AdNetworkRoutesRaw)
